import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import Form from "../../Redirecionamentos/form";
import Select from "../../../../components/Select";
import auth from "../../../../utils/auth";
import cfg from "../../../../utils/config";
import axios from "axios";
import helper from "../../../../utils/helper";
import { LnsCadastroRapidoContext } from "../../../../contexts/LnsCadastroRapido";
import ReactLoading from "react-loading"

const Redirecionamentos = forwardRef((props, ref) => {
  const userInfo = auth.getUserInfo();
  const formRef = useRef();

  const { setRedirectId, redirectId, setSelectedRedirectType, selectedRedirectType, applicationId, deviceId } = useContext(LnsCadastroRapidoContext);

  const [redirectType, setRedirectType] = useState(null);
  const [selectedRedirect, setSelectedRedirect] = useState(null);
  const [redirectOptions, setRedirectOptions] = useState([]);
  const [loadingRedirects, setLoadingRedirects] = useState(false);
  const [hasRedirects, setHasRedirects] = useState(false);

  const redirectTypeOptions = [
    { label: "Novo Redirecionamento", value: "newRedirect" },
    { label: "Usar Redirecionamento Existente", value: "selectRedirect" }
  ];

  useEffect(() => {
    getRedirects();
  }, []);

  useEffect(() => {
    if (selectedRedirectType) {
      setRedirectType(selectedRedirectType);
    }
  }, [selectedRedirectType]);

  useEffect(() => {
    if (selectedRedirectType === "selectRedirect" && redirectId) {
      setSelectedRedirect(redirectId);
    }
  }, [selectedRedirectType, redirectId]);

  useImperativeHandle(ref, () => ({
    onNext: async () => {
      if (redirectType === "newRedirect") {
        const result = await formRef.current?.handleQuickRegister();

        if (!result?.success) {
          return false;
        }

        setRedirectId(result.redirectId);
        setSelectedRedirectType("newRedirect");

        return true;
      }

      if (redirectType === "selectRedirect") {
        if (!selectedRedirect) {
          const span = document.getElementById("validacao-redirecionamento");
          if (span) {
            span.innerHTML = "Selecione um redirecionamento.";
          }

          return false;
        }

        const result = await formRef.current?.handleQuickRegister();

        if (!result?.success) {
          return false;
        }

        return result;
      }

      const span = document.getElementById("validacao-tipo-redirecionamento");
      if (span) {
        span.innerHTML = "Selecione o tipo de redirecionamento.";
      }

      return false;
    }
  }));

  const getRedirects = async () => {
    try {
      setLoadingRedirects(true);

      const requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/redirecionamentos/`;

      const configMe = {
        headers: {
          Authorization: `Bearer ${auth.getToken()}`
        }
      };

      const { data } = await axios.get(requestURL, configMe);

      const optionsRedirect = data.results.map((item) => ({
        label: item.nome,
        value: item.id
      }));

      setHasRedirects(!!optionsRedirect.length)
      setRedirectOptions(optionsRedirect);
      if (!optionsRedirect.length) setRedirectType("newRedirect")
    } catch (error) {
      console.error("Erro ao buscar redirecionamentos:", error);
      setRedirectOptions([]);
    } finally {
      setLoadingRedirects(false);
    }
  };

  const handleRedirectTypeChange = (option) => {
    if (selectedRedirectType) return;

    setRedirectType(option.value);

    const spanTipo = document.getElementById("validacao-tipo-redirecionamento");
    if (spanTipo) spanTipo.innerHTML = "";

    if (option?.value !== "selectRedirect") {
      setSelectedRedirect(null);
    }
  };

  const handleSelectRedirect = (option) => {
    if (selectedRedirectType === "selectRedirect") return;

    setSelectedRedirect(option.value);

    const spanRedirect = document.getElementById("validacao-redirecionamento");
    if (spanRedirect) spanRedirect.innerHTML = "";
  };

  return (
    <>
      <div className="hdv-default-header mx-3">
        <span className="screen-menu-desc">
          <i
            className="fa fa-info-circle fa-20px"
            title='Informações do Cadastro de Redirecionamentos'
            style={{ cursor: "pointer", marginTop: '8px', marginRight: '5px' }}
            onClick={() =>
              helper.dispatchEvent("showAviso", {
                message: `
                    Define para onde os dados recebidos serão enviados:<br /><br />
                    <strong>Interno</strong> — Visualização e processamento diretamente na plataforma. Requer plano de acesso contratado.<br /><br />
                    <strong>Externo</strong> — Dados enviados para um broker MQTT de sua escolha, para integração com seus próprios sistemas.
                `,
              })
            }
          />
          <h4>Redirecionamento</h4>
          <div className="gray-background">
            <i className="las la-reply la-2x"></i>
          </div>
        </span>
      </div>
      {loadingRedirects ? (
        <div className="loading-screen-overlay">
          <ReactLoading
            type="spin"
            color="var(--background-menu)"
            width={40}
          />
        </div>
      )
        :
        <div className="hdv-form-default">
          <div className="row">
            <div className="col-md-6">
              <label className="required">
                Tipo de Redirecionamento
              </label>
              <Select
                options={redirectTypeOptions}
                value={redirectType}
                onChange={handleRedirectTypeChange}
                resolveValueFromOptions
                disabled={!!selectedRedirectType || !hasRedirects}
              />
              <span id="validacao-tipo-redirecionamento"></span>
            </div>

            {redirectType === "selectRedirect" && (
              <div className="col-md-6">
                <label className="required">Redirecionamento</label>
                <Select
                  options={redirectOptions}
                  value={selectedRedirect}
                  onChange={handleSelectRedirect}
                  resolveValueFromOptions
                  disabled={(selectedRedirectType === "selectRedirect" && redirectId) || loadingRedirects}
                />
                <span id="validacao-redirecionamento"></span>
              </div>
            )}
          </div>

          {(redirectType === "newRedirect" || selectedRedirect) && (
            <>
              <hr />
              <Form
                ref={formRef}
                isQuickRegister
                redirectId={selectedRedirect}
                applicationId={applicationId}
                deviceId={deviceId}
              />
            </>
          )}
        </div>
      }
    </>
  );
});

export default Redirecionamentos;